// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"f0f838e6","488":"a8dd2fd7"}[chunkId] + ".chunk.js";
};